module.exports = __webpack_public_path__ + "media/images/emblems/Cevio-coat_of_arms-ffcc7e8f172359d065ec6916f885e02f.svg";